import { Injectable } from '@angular/core';
import { getNewRelicAgent } from '../../config/new-relic';

export type LogLevel = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';
export type LogAttributes = Record<
    string,
    string | number | boolean | null | undefined
>;

const CONSOLE_METHOD: Record<LogLevel, 'debug' | 'info' | 'warn' | 'error'> = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
};

/**
 * Sends logs to New Relic Browser when the agent is running,
 * otherwise writes them to the console (local development).
 */
@Injectable({ providedIn: 'root' })
export class LoggerService {
    public debug(message: string, attributes?: LogAttributes) {
        this.log('DEBUG', message, attributes);
    }

    public info(message: string, attributes?: LogAttributes) {
        this.log('INFO', message, attributes);
    }

    public warn(message: string, attributes?: LogAttributes) {
        this.log('WARN', message, attributes);
    }

    public error(message: string, attributes?: LogAttributes) {
        this.log('ERROR', message, attributes);
    }

    private log(
        level: LogLevel,
        message: string,
        attributes: LogAttributes = {}
    ) {
        const agent = getNewRelicAgent();

        if (agent) {
            agent.log(message, { level, customAttributes: attributes });
            return;
        }

        console[CONSOLE_METHOD[level]](message, attributes);
    }
}
